import PaintShopProductionWorkspace from '../../placeholders/PaintShopProductionWorkspace';

export default PaintShopProductionWorkspace;
